<template>
	<span :class="['inline-flex items-center', classes]" v-html="svgContent"></span>
</template>

<script>
	const themeIcons = import.meta.glob('../../../../svg/theme/v1/**/*.svg', { eager: true, query: '?raw', import: 'default' });

	export default {
		name: 'ThemeIcon',
		props: {
			icon: {
				type: String,
				required: true
			},
			type: {
				type: String,
				default: 'nav',
				validator: (value) => ['nav', 'footer', 'icons'].includes(value)
			},
			classes: {
				type: String,
				default: 'w-4 h-4'
			}
		},

		computed: {
			svgContent() {
				const matchingKey = Object.keys(themeIcons).find(k => k.endsWith('/' + this.type + '/' + this.icon + '.svg'));
				if (!matchingKey) {
					console.warn(`Theme icon not found: ${this.type}/${this.icon}.svg`);
					return '';
				}
				return themeIcons[matchingKey];
			}
		}
	}
</script>
